import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinhinjewadi() {



  const cardData = {
"keyword": "Mini Bus On Rent in Hinjewadi",

"headingDescription":
  "Aaradhya Travels offers reliable Mini Bus On Rent in Hinjewadi for corporate travel, employee transportation, family trips, weddings, school tours, airport transfers, and outstation group journeys. Our fleet includes comfortable 14, 17, 20, 25, 32, and 35-seater mini buses equipped with air-conditioning, pushback seats, spacious interiors, and experienced drivers familiar with Hinjewadi IT Park, Wakad, Baner, and Pune highway routes. We provide safe, comfortable, and punctual group transportation with doorstep pickup from Hinjewadi Phase 1, Phase 2, Phase 3, and nearby residential and corporate areas.",

"topPlaces": [
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and cool weather. It is perfect for peaceful group travel and family sightseeing tours from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a calm hill station known for Arthur Lake, Randha Falls, and natural beauty. It is a perfect relaxing destination for group tours and weekend trips from Pune."
},
  {
"title": "Khandala",
"description":
"Khandala is a popular hill station near Pune known for its misty mountains, scenic viewpoints, waterfalls, and pleasant weather. It is a favorite weekend getaway for families and group travelers using buses and Tempo Travellers for comfortable short road trips."
},
{
"title": "Lonavala",
"description":
"Lonavala is one of the most famous hill stations near Pune known for green valleys, Tiger Point, Bhushi Dam, caves, and monsoon beauty. It is widely visited by family groups, corporate teams, and friends for short and comfortable bus trips."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city near Pune known for lakeside promenade, colorful buildings, cafes, and peaceful environment. It is ideal for relaxed group outings, corporate trips, and family leisure travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a scenic lakeside destination near Lonavala known for camping, sunset views, bonfire nights, and peaceful surroundings. It is highly popular among group travelers and weekend tourists from Pune."
},

{
"title": "Kamshet",
"description":
"Kamshet is a scenic hill region near Pune famous for paragliding, green valleys, and peaceful landscapes. It is popular among adventure lovers and group travelers looking for short trips."
},
{
"title": "Mulshi",
"description":
"Mulshi is a beautiful lake and dam destination near Pune surrounded by hills and greenery. It is a popular picnic and one-day group travel destination for families and corporate outings."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic mountain pass known for waterfalls, fog, and lush greenery during monsoon. It is a favorite short road trip destination for group travelers from Pune."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury hill township near Lonavala known for scenic landscapes, lakes, and premium resorts. It is popular for corporate trips, luxury group outings, and weekend leisure travel."
}
],



services: [
  {
    name: "Mini Bus Hire Hinjewadi Pune",
    description: "Mini bus hire Hinjewadi Pune service provides reliable transportation for corporate travel, office outings, airport transfers, employee movement, and group travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for business and tourist passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from offices, homes, hotels, and commercial hubs across Hinjewadi Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Hinjewadi IT Park Bus Rental",
    description: "Hinjewadi IT park bus rental service offers dependable transportation for IT employees, office shuttle services, corporate meetings, and business travel requirements. Spacious buses ensure smooth travel suitable for daily office commutes and employee transportation. Professional drivers ensure reliable transportation and timely pickup services throughout the route. Pickup services are available from IT companies, offices, hotels, and residential locations across Hinjewadi Pune. Flexible booking options allow convenient IT park bus rental reservations."
  },
  {
    name: "Corporate Bus Hinjewadi Pune",
    description: "Corporate bus Hinjewadi Pune service provides professional transportation for office staff, conferences, corporate events, business meetings, and employee travel. Comfortable buses ensure smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business parks across Hinjewadi Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Mini Bus for Office Pickup Hinjewadi",
    description: "Mini bus for office pickup Hinjewadi service offers reliable transportation for daily employee movement, corporate staff pickup, and office shuttle requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for IT employees and office teams. Professional drivers ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, apartments, offices, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient office pickup mini bus reservations."
  },
  {
    name: "Hinjewadi Employee Transport Bus",
    description: "Hinjewadi employee transport bus service provides dependable transportation for office staff, company employees, business travel, and corporate commute requirements. Spacious buses ensure smooth travel suitable for regular employee transportation and office shift movements. Professional chauffeurs ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from offices, IT parks, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient employee transport bus reservations."
  },
  {
    name: "AC Mini Bus Hinjewadi",
    description: "AC mini bus Hinjewadi service provides premium air-conditioned transportation for office travel, airport transfers, sightseeing tours, and group journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions and business travel. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, homes, hotels, and commercial hubs across Hinjewadi Pune. Flexible booking options allow convenient AC mini bus reservations."
  },
  {
    name: "Non AC Mini Bus Hinjewadi",
    description: "Non AC mini bus Hinjewadi service offers affordable transportation for employee travel, educational tours, local sightseeing, office outings, and group journeys. Spacious seating ensures comfortable travel suitable for budget-friendly transportation requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient non AC mini bus reservations."
  },
  {
    name: "17 Seater Hinjewadi Mini Bus",
    description: "17 seater Hinjewadi mini bus service provides spacious transportation for office outings, family trips, educational tours, and corporate group travel requirements. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from offices, homes, hotels, railway stations, and airports across Hinjewadi Pune. Flexible booking options allow convenient 17 seater mini bus reservations."
  },
  {
    name: "25 Seater Hinjewadi Bus",
    description: "25 seater Hinjewadi bus service offers reliable transportation for corporate events, employee travel, wedding functions, educational tours, and tourist group journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for larger passenger groups. Professional chauffeurs ensure safe driving and punctual transportation services throughout the route. Pickup services are available from offices, hotels, homes, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient 25 seater bus reservations."
  },
  {
    name: "Hinjewadi to Pune City Bus",
    description: "Hinjewadi to Pune city bus service provides dependable transportation for daily office commute, sightseeing travel, airport transfers, and corporate travel requirements. Comfortable buses ensure smooth journeys suitable for local passenger travel and employee movement. Professional drivers ensure reliable transportation and timely pickup services throughout the route. Pickup services are available from offices, homes, hotels, and residential locations across Hinjewadi and Pune city. Flexible booking options allow convenient Pune city bus reservations."
  },
  {
    name: "Hinjewadi to Wakad Bus Hire",
    description: "Hinjewadi to Wakad bus hire service offers comfortable transportation for office travel, employee commute, wedding functions, and local group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for short-distance passenger movement. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, homes, hotels, and residential areas across Hinjewadi and Wakad Pune. Flexible booking options allow convenient Wakad bus hire reservations."
  },
  {
    name: "Hinjewadi Wedding Bus Rental",
    description: "Hinjewadi wedding bus rental service provides stylish transportation for marriage ceremonies, bridal parties, family gatherings, and wedding guest travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional drivers ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient wedding bus rental reservations."
  },
  {
    name: "Hinjewadi Group Travel Bus",
    description: "Hinjewadi group travel bus service offers spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable buses ensure smooth travel suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from offices, homes, hotels, railway stations, and airports across Hinjewadi Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Hinjewadi Outstation Bus Pune",
    description: "Hinjewadi outstation bus Pune service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, and family vacations. Spacious seating and luggage space ensure comfortable highway travel suitable for tourist and corporate travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "Hinjewadi Shuttle Service Bus",
    description: "Hinjewadi shuttle service bus provides reliable transportation for office staff movement, employee transfers, airport travel, and daily commute requirements. Spacious buses ensure smooth travel suitable for IT employees and business passengers. Professional chauffeurs ensure dependable transportation and timely pickup services throughout the route. Pickup services are available from offices, homes, hotels, and IT parks across Hinjewadi Pune. Flexible booking options allow convenient shuttle service bus reservations."
  },
  {
    name: "Hinjewadi Corporate Outing Bus",
    description: "Hinjewadi corporate outing bus service offers professional transportation for office picnics, employee outings, conferences, and team-building travel requirements. Comfortable buses ensure smooth journeys suitable for corporate groups and business travel. Professional drivers ensure reliable transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, and commercial hubs across Hinjewadi Pune. Flexible booking options allow convenient corporate outing bus reservations."
  },
  {
    name: "Hinjewadi Airport Pickup Bus Pune",
    description: "Hinjewadi airport pickup bus Pune service provides dependable transportation for airport transfers, business travelers, office staff, and group passenger movement. Spacious buses ensure comfortable travel suitable for local and outstation airport transportation requirements. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from Pune Airport, offices, homes, hotels, and IT parks across Hinjewadi Pune. Flexible booking options allow convenient airport pickup bus reservations."
  },
  {
    name: "Hinjewadi Baner Bus Hire",
    description: "Hinjewadi Baner bus hire service offers reliable transportation for office commute, wedding travel, sightseeing tours, and local passenger movement requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for family and corporate groups. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Hinjewadi and Baner Pune. Flexible booking options allow convenient Baner bus hire reservations."
  },
  {
    name: "Hinjewadi Kharadi Bus Service",
    description: "Hinjewadi Kharadi bus service provides comfortable transportation for IT employees, office commute, business meetings, and corporate travel requirements. Spacious buses ensure smooth journeys suitable for daily office transportation and group passenger movement. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from offices, hotels, homes, and business parks across Hinjewadi and Kharadi Pune. Flexible booking options allow convenient Kharadi bus service reservations."
  },
  {
    name: "Hinjewadi Magarpatta Bus Rental",
    description: "Hinjewadi Magarpatta bus rental service offers dependable transportation for office commute, corporate travel, employee movement, and sightseeing journeys. Comfortable seating and smooth travel ensure pleasant journeys suitable for business and tourist passengers. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Hinjewadi and Magarpatta Pune. Flexible booking options allow convenient Magarpatta bus rental reservations."
  },
  {
    name: "Hinjewadi Family Trip Bus",
    description: "Hinjewadi family trip bus service provides spacious transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Comfortable buses ensure smooth travel suitable for local and outstation family group journeys. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Hinjewadi Affordable Bus Rental",
    description: "Hinjewadi affordable bus rental service offers economical transportation for employee travel, educational tours, wedding functions, sightseeing journeys, and group travel requirements. Spacious buses ensure comfortable travel suitable for budget-friendly local and outstation journeys. Professional drivers ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Hinjewadi Pune. Flexible booking options allow convenient affordable bus rental reservations."
  },
  {
    name: "Hinjewadi Luxury Mini Bus",
    description: "Hinjewadi luxury mini bus service provides premium transportation with elegant interiors and spacious seating for corporate travel, airport transfers, sightseeing tours, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, homes, luxury hotels, and airports across Hinjewadi Pune. Flexible booking options allow convenient luxury mini bus reservations."
  },
  {
    name: "Hinjewadi Staff Transport Bus",
    description: "Hinjewadi staff transport bus service offers reliable transportation for office staff, IT employees, company shuttle services, and daily business commute requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for employee transportation. Professional drivers ensure dependable transportation and timely pickup services throughout the route. Pickup services are available from offices, homes, hotels, and residential areas across Hinjewadi Pune. Flexible booking options allow convenient staff transport bus reservations."
  },
  {
    name: "Hinjewadi Booking Bus Pune",
    description: "Hinjewadi booking bus Pune service provides dependable transportation for office outings, sightseeing tours, airport transfers, employee travel, and group journey requirements. Comfortable buses ensure smooth travel suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Hinjewadi Pune. Flexible booking options allow convenient bus booking reservations."
  }
],

tableData: [
  ["Mini Bus Hire Hinjewadi Pune", "Hinjewadi IT Park Bus Rental"],
  ["Corporate Bus Hinjewadi Pune", "Mini Bus for Office Pickup Hinjewadi"],
  ["Hinjewadi Employee Transport Bus", "AC Mini Bus Hinjewadi"],
  ["Non AC Mini Bus Hinjewadi", "17 Seater Hinjewadi Mini Bus"],
  ["25 Seater Hinjewadi Bus", "Hinjewadi to Pune City Bus"],
  ["Hinjewadi to Wakad Bus Hire", "Hinjewadi Wedding Bus Rental"],
  ["Hinjewadi Group Travel Bus", "Hinjewadi Outstation Bus Pune"],
  ["Hinjewadi Shuttle Service Bus", "Hinjewadi Corporate Outing Bus"],
  ["Hinjewadi Airport Pickup Bus Pune", "Hinjewadi Baner Bus Hire"],
  ["Hinjewadi Kharadi Bus Service", "Hinjewadi Magarpatta Bus Rental"],
  ["Hinjewadi Family Trip Bus", "Hinjewadi Affordable Bus Rental"],
  ["Hinjewadi Luxury Mini Bus", "Hinjewadi Staff Transport Bus"],
  ["Hinjewadi Booking Bus Pune", "Mini Bus Hire Hinjewadi Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Hinjewadi Mini Bus Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Hinjewadi mini bus service with comfortable vehicles, professional drivers, and smooth travel arrangements for family vacations, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Hinjewadi Mini Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Hinjewadi mini bus rental packages with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking for Hinjewadi Travel",
        WhyChoosedescription: "Our Pune to Hinjewadi mini bus service operates 24 hours for weekend trips, sightseeing tours, family vacations, corporate outings, and outstation travel requirements."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable hill station travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Hinjewadi Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day Hinjewadi sightseeing trips, weekend getaways, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Mini Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses suitable for families, tourist groups, corporate teams, and holiday travelers."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Ghat Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Hinjewadi ghat roads and ensure safe driving, smooth journeys, and comfortable outstation travel experiences."
      }
    ]
  };

  const faqData = [
  {
    question: "What is Mini Bus on rent in Hinjewadi?",
    answer: "Mini Bus on rent in Hinjewadi by Aaradhya Travels provides comfortable and affordable group transportation for corporate travel, weddings, events, and outstation trips."
  },
  {
    question: "Is mini bus rental in Hinjewadi available 24/7?",
    answer: "Yes, Aaradhya Travels offers 24/7 mini bus rental service in Hinjewadi for both local and outstation travel needs."
  },
  {
    question: "What seating capacities are available in mini buses?",
    answer: "We provide mini buses with seating capacities ranging from 18-seater to 35-seater depending on group size and requirement."
  },
  {
    question: "Can I book a mini bus for corporate travel in Hinjewadi?",
    answer: "Yes, mini buses are available for corporate employee transport, IT park travel, meetings, and office outings in Hinjewadi."
  },
  {
    question: "Do you provide mini bus rental for weddings and events?",
    answer: "Yes, Aaradhya Travels offers mini buses for weddings, family functions, parties, and special events with comfortable seating."
  },
  {
    question: "Are mini buses available for outstation trips from Hinjewadi?",
    answer: "Yes, mini bus rental service is available for outstation trips to Mumbai, Pune, Lonavala, Hinjewadi, and other destinations."
  },
  {
    question: "Are your mini buses air-conditioned?",
    answer: "Yes, all mini buses provided by Aaradhya Travels are fully air-conditioned and well-maintained for a comfortable journey."
  },
  {
    question: "Can I book a mini bus for airport transfer in Pune?",
    answer: "Yes, mini bus rental service is available for Pune airport pickup and drop for groups and corporate clients."
  },
  {
    question: "How can I book mini bus on rent in Hinjewadi?",
    answer: "You can easily book a mini bus by contacting Aaradhya Travels through phone, WhatsApp, or online booking request."
  },
  {
    question: "Is pricing for mini bus rental in Hinjewadi affordable?",
    answer: "Yes, Aaradhya Travels offers competitive and transparent pricing for mini bus rentals with no hidden charges."
  }
];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Ajinkya More",
    feedback:
      "Group travel from Hinjewadi became much easier with a mini bus arranged by Aaradhya Travels. The journey stayed comfortable even with heavy traffic, and everyone reached the destination together without any confusion.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Aaradhya Travels provided a mini bus on rent in Hinjewadi for our office outing, and the experience was very well managed. The vehicle was clean, spacious, and made group coordination effortless.",
    rating: 5
  }
];







  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Hinjewadi",
  "image": "https://www.aaradhyatravels99.com/assets/images/mini-bus-on-rent-in-hinjewadi.jpg",
  "description": "Book Mini Bus on rent in Hinjewadi Pune with Aaradhya Travels for corporate travel, IT park employee transport, weddings, airport transfers, and outstation trips. Available AC and Non-AC 17 and 25 seater mini buses for group travel and office pickups.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/mini-bus-on-rent-in-hinjewadi"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Mini Bus on Rent in Hinjewadi Pune | IT Park & Corporate Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Mini Bus on rent in Hinjewadi Pune with Aaradhya Travels. Affordable AC and Non-AC 17 and 25 seater mini bus available for IT park transport, corporate travel, office pickup, weddings, group tours, and outstation trips."
  />

  <meta
    name="keywords"
    content="Mini bus hire Hinjewadi Pune, Hinjewadi IT park bus rental, Corporate bus Hinjewadi Pune, Mini bus for office pickup Hinjewadi, Hinjewadi employee transport bus, AC mini bus Hinjewadi, Non AC mini bus Hinjewadi, 17 seater Hinjewadi mini bus, 25 seater Hinjewadi bus, Hinjewadi to Pune city bus, Hinjewadi to Wakad bus hire, Hinjewadi wedding bus rental, Hinjewadi group travel bus, Hinjewadi outstation bus Pune, Hinjewadi shuttle service bus, Hinjewadi corporate outing bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinhinjewadi;